import { BBFL, BBFLDisplayType } from '@cox/core-ui8/dist/BBFL'
import { useBBFLContext } from '@cox/core-ui8/dist/BBFLContext'
import { useFlexOffers } from '@cox/core-ui8/dist/useFlexOffers'

import { ReactBBFLProps } from './types'
import withAEM from '../../hoc/withAEM'
import { getConditionResult, getNestedValue } from '../../utils/rule-builder-util'
import ReactButton from '../ReactButton'
import IsInEditorText from '../shared/IsInEditorText'

const ReactBBFL = (props: ReactBBFLProps): JSX.Element => {
  const {
    isInEditor = false,
    display,
    cardsSize = 0,
    bbflOfferVariable = '',
    internetOfferCondition = '',
    backToOffersAnchor = '',
    ruleExpression = ''
  } = props
  const BBFLWithAEM = withAEM(BBFL)

  if (!document.getElementById('cox-bbfl') && !isInEditor) {
    return <></>
  }
  const flexOffers = useFlexOffers(ruleExpression)
  const { bbflContext } = useBBFLContext()

  if (display == BBFLDisplayType.SECTION) {
    const bbflOfferString: any = []
    const backToOffersAnchorId: any = []
    const bbflComponentNames: any = []
    const bbflFlexOffers = {
      offers: bbflContext,
      discounts: [],
      cinfos: [],
      success: false,
      loading: false,
      error: false
    }

    bbflFlexOffers?.offers?.map((item: any, index: number) => {
      const result = getConditionResult(internetOfferCondition, bbflFlexOffers, index)
      if (result) {
        const bbflItems: any = getNestedValue(bbflOfferVariable, bbflFlexOffers, index, false)
        const updateBBFLProps = (bbflItem: string) => {
          bbflOfferString.push(bbflItem)
          backToOffersAnchorId.push(getNestedValue(backToOffersAnchor, bbflFlexOffers, index))
          bbflComponentNames.push(item?.componentName)
        }
        bbflItems
          ? JSON.parse(bbflItems)?.map((bbflItem: any) => {
              updateBBFLProps(JSON.stringify(new Array(bbflItem)))
            })
          : updateBBFLProps(bbflItems)
      }
    })
    if (bbflOfferString.length > 0 || isInEditor) {
      return (
        <BBFLWithAEM
          {...props}
          bbflData={bbflOfferString}
          backToOffersAnchorId={backToOffersAnchorId}
          compName={'BBFL'}
          bbflComponentName={bbflComponentNames}
        />
      )
    }
    return <></>
  } else if (display == BBFLDisplayType.INDIVIDUAL) {
    if (eval(internetOfferCondition) || isInEditor) {
      return <BBFLWithAEM {...props} bbflData={bbflOfferVariable} compName={'BBFL'} />
    }
    return <></>
  } else if (display == BBFLDisplayType.BUTTON) {
    // View all button is part of rule-builder, flexoffers is passed from rule-builder here
    const displayButton =
      flexOffers?.offers?.some((item: any, index: number) => {
        const result = getConditionResult(internetOfferCondition, flexOffers, index)
        return result && display == BBFLDisplayType.BUTTON && index < cardsSize
      }) || false
    if (displayButton || isInEditor) {
      return (
        <>
          {IsInEditorText(isInEditor, 'Edit BBFL Component', '', true)}
          <ReactButton {...props} cssClass={` my-6`} />
        </>
      )
    }
    return <></>
  } else {
    return (
      <>
        <BBFLWithAEM isInEditor={isInEditor} compName={'BBFL'} />
        {IsInEditorText(isInEditor, 'Please Select BBFL Display Type', '', true)}
      </>
    )
  }
}

export default ReactBBFL
